<mg-filter-form [filter]="filter" [formGroup]="form">
    <ng-container quickFilter>
        <mat-form-field>
            <mat-label>Naam</mat-label>
            <input matInput formControlName="name" name="Name">
            <button matSuffix mat-icon-button type="button" (click)="clear('name')" type="button" tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </ng-container>
</mg-filter-form>